import React from "react";
import { Skeleton } from "../";
var DataTableFooter = function (_a) {
    var id = _a.id, totalData = _a.totalData, loading = _a.loading, data = _a.data, columns = _a.columns;
    var getHeaderWidth = function (columnId, defaultWidth) {
        if (!columnId) {
            // window.location.reload();
            return defaultWidth;
        }
        var headerCell = document.querySelector("#" + id + " .data-grid-head [data-column=\"" + columnId + "\"]");
        return headerCell ? parseInt(headerCell.style.minWidth) : defaultWidth;
    };
    /**
     * Returns skeleton loader for data table body
     * @returns {JSX}
     */
    var skeletonLoader = function () {
        return React.createElement("div", { className: "abs-skeleton-loader " + (data.length > 0 ? 'bottom' : 'top') }, Array.from(new Array(1)).map(function (i, e) {
            return React.createElement("div", { key: e, className: "data-grid-row" }, columns.filter(function (c) { return typeof c !== 'undefined'; }).map(function (col, f) {
                var left = 0;
                var headerWidth = getHeaderWidth(col.id, col.width);
                if (col.fixed) {
                    left = columns.slice(0, f).reduce(function (sum, v) { return sum + v.width; }, 0);
                }
                return (React.createElement("div", { key: f, "data-column": col.id, className: "data-grid-cell " + (col.fixed ? 'fixed-column' : ''), style: { minWidth: headerWidth, maxWidth: headerWidth, left: left + 'px' } },
                    React.createElement(Skeleton, { height: 30 })));
            }));
        }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "data-grid-footer-container" },
            React.createElement("div", { className: "data-grid", "aria-label": "Data Grid" },
                React.createElement("div", { className: "data-grid-head" },
                    React.createElement("div", { className: "data-grid-row" }, totalData === null || totalData === void 0 ? void 0 : totalData.map(function (column, index) {
                        if (!column.invisible) {
                            var left = 0;
                            if (column.fixed) {
                                left = totalData
                                    .slice(0, index)
                                    .reduce(function (sum, v) { return sum + v.width; }, 0);
                            }
                            var headerContent = column.headerTooltip !== false ? (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                                column.label ? React.createElement("span", { style: { fontWeight: column.fontWeight || "normal", color: "#333" } }, column.label) : React.createElement("span", null, "\u2014"),
                                React.createElement("span", { style: { fontWeight: column.fontWeight || "normal", fontSize: 12, color: "#acacac", minHeight: 15 } }, column.footerLabel || ""))) : (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                                column.label ? column.label : React.createElement("span", null, "\u2014"),
                                React.createElement("span", { style: { fontWeight: column.fontWeight || "normal", fontSize: 12, color: "#acacac", minHeight: 15 } }, column.footerLabel || "")));
                            return (React.createElement("div", { key: column.id, "data-column": column.id, "data-min-width": column.width, className: "data-grid-cell " + (column.fixed ? "fixed-column" : ""), style: {
                                    minWidth: column.width,
                                    maxWidth: column.width,
                                    left: left + "px",
                                    textAlign: column.align
                                } },
                                headerContent,
                                column.resizable !== false && (React.createElement("div", { className: "resizer" }))));
                        }
                        else {
                            return (React.createElement(React.Fragment, null));
                        }
                    })),
                    loading && skeletonLoader())))));
};
export default DataTableFooter;
